export interface IHaloDropDown {
  text: string;
  value: string | number;
}

export function textToDropDownData(strArr: string[], indexAsValue: boolean) {
  const _data: IHaloDropDown[] = [];
  strArr.forEach((element, index) => {
    _data.push({
      text: element,
      value: indexAsValue ? index : element
    });
  });
  return _data;
}
